import { observer } from 'mobx-react-lite'
import { TableSearch } from 'shared/ui/TableNew'
import { Divider } from 'shared/ui'
import { BulkActions } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/AircallBulkActions/BulkActions'
import { createAircallColumns } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/AircallTable/columns/aircallColumns'
import { AircallTable } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/AircallTable/AircallTable'
import { RejectAssignedNumbersAlert } from 'pages/settings/ui/RejectAssignedNumbersAlert/RejectAssignedNumbersAlert'
import { type AircallNumbersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersStore'
import { UpdateAircallNumbersLayout } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/UpdateAircallNumbersLayout/UpdateAircallNumbersLayout'
type IAssignedNumbersProps = {
  store: AircallNumbersStore
  aircallLink: string
}

export const UnassignedNumbers = observer(({ store, aircallLink }: IAssignedNumbersProps) => {
  const { numbersListStore } = store
  const columns = createAircallColumns(numbersListStore)
  const {
    rejectAssignedNumbers,
    clearRejectAssignedNumbers,
    rejectMessage,
    clearRejectAssignedMessage,
  } = numbersListStore
  const isUnassignedNumbersEmpty = numbersListStore.unassignedNumbersLength === 0

  return (
    <>
      {!!rejectMessage?.length ? (
        rejectMessage.map((error, index) => {
          return (
            <RejectAssignedNumbersAlert
              key={index}
              airCallLink={aircallLink}
              rejectAssignedNumbers={rejectAssignedNumbers}
              rejectMessage={error}
              clearRejectAssignedNumbers={() => {
                clearRejectAssignedMessage(index)
                clearRejectAssignedNumbers()
              }}
            />
          )
        })
      ) : (
        <RejectAssignedNumbersAlert
          airCallLink={aircallLink}
          rejectAssignedNumbers={rejectAssignedNumbers}
          clearRejectAssignedNumbers={() => {
            clearRejectAssignedNumbers()
            clearRejectAssignedMessage()
          }}
        />
      )}

      <Divider sx={{ marginBottom: '16px' }} />
      {!isUnassignedNumbersEmpty && (
        <TableSearch value={numbersListStore.search} onChange={numbersListStore.setSearch} />
      )}
      <AircallTable
        ariaLabel={'UnassignedNumbers'}
        store={numbersListStore}
        rows={numbersListStore.unassignedItems}
        hidePagination={true}
        emptyContent={
          isUnassignedNumbersEmpty ? <UpdateAircallNumbersLayout store={numbersListStore} /> : null
        }
        notFoundMessage={isUnassignedNumbersEmpty ? 'No numbers' : 'No results found'}
        columns={[columns.numberCell, columns.statusCell, columns.actionCell]}
        withCheckbox={true}
        withoutSelectedCount={false}
        headerLeftContentProps={{
          actionsContent: <BulkActions store={numbersListStore} />,
        }}
      />
    </>
  )
})
